import { render, staticRenderFns } from "./PlatformMegaMenu.vue?vue&type=template&id=702e284a&scoped=true"
import script from "./PlatformMegaMenu.vue?vue&type=script&lang=ts"
export * from "./PlatformMegaMenu.vue?vue&type=script&lang=ts"
import style0 from "./PlatformMegaMenu.vue?vue&type=style&index=0&id=702e284a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702e284a",
  null
  
)

export default component.exports